import React, { useState, useEffect, useRef } from 'react';
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import Button from '@mui/material/Button';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Toolbar from '@mui/material/Toolbar';
import TaskIcon from '@mui/icons-material/Task';
import AddIcon from '@mui/icons-material/Add';
import axios from '../../../../api/axios';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import {
    FormControl, Radio,
    RadioGroup, FormLabel
} from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Snackbar from '@mui/material/Snackbar';
import VisibilityIcon from '@mui/icons-material/Visibility';
import IconButton from '@mui/material/IconButton';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import JoditEditor from "jodit-react"
import Alert from '@mui/material/Alert';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ApplicationStore from '../../../../utils/localStorageUtil';
import MUIRichTextEditor from "mui-rte";
import { convertToRaw } from 'draft-js';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useAuthContext } from '../../../../context/AuthContext';
import { makeStyles } from '@mui/styles';
import { caES } from '@mui/material/locale';
import { Editor } from "primereact/editor";
const API_BASE_URL = "http://stageback.getcoveredcanada.ca/";


var URL = "./product";
var useStyles = makeStyles({
    editor: {
        border: '1px solid #ccc',
        borderRadius: '4px',
        padding: '8px',
    },
});


function WarrantyProducts() {
    var { user_email } = useAuthContext();
    var dealership = ApplicationStore().getStorage('dealership');
    var navigate = useNavigate();
    var { state } = useLocation();
    var [id, setId] = useState('');
    var [categoryName, setCategoryName] = useState('');
    var [productCategory, setProductCategory] = useState('');
    var [alertOpen, setAlertopen] = useState(false);
    var [severity, setSeverity] = useState('');
    var [message, setMessage] = useState('');
    // var [type, setType] = useState('add');
    var [category, setCategory] = useState("");
    var [subCategory, setSubCategory] = useState("");
    var [subCat, setSubCat] = useState("");
    var [subCatText, setSubCatText] = useState("");
    var [userDealership, setUserdealership] = useState("");
    var [userSalesrep, setUsersalesrep] = useState("");
    var [warrantyProtectionText, setWarrantyProtectionText] = useState("");
    var [warrantyprotection, setWarrantyprotection] = useState("");
    var [warrantyProtectionList, setWarrantyProtectionList] = useState([]);
    var [dealershipArray, setDealershipArray] = useState([]);
    var [salesrepArray, setSalesrepArray] = useState([]);
    var [categoryList, setCategoryList] = useState([]);
    var [subcategoryList, setsubcategoryList] = useState([]);
    var [productData, setProductData] = useState([{ productName: "", productPrice: "", visiblity: 1, productMonth: "", productKM: "" }]);
    var classes = useStyles();
    var editor = useRef(null);
    var [content, setContent] = useState("");
    var [deductibleAmount, setDeductibleAmount] = useState("");
    var [deductibleType, setDeductibleType] = useState(1);
    var [warrantyActionType, setWarrantyActionType] = useState("");
    const [pdfFileName, setPdfFileName] = useState("");


    var productCategoryType = ['Dealership', 'Salesrep'];

    var [pdf, setPdf] = useState("");

    var { value, type } = state;

    var handleClick = () => {
        setAlertopen(true);
    };

    var handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setAlertopen(false);
    };

    var handleRadioChange = (event) => {
        var value = event.target.value;
        setDeductibleType(value);

        if (value == 1) {
            setDeductibleAmount(""); // Clear textbox when Native is selected
        }
    };

    var serviceMethod = async (mainURL, method, data, handleSuccess, handleException) => {
        console.log("helo")
        try {
            var response = await axios.post(mainURL, data);
            return handleSuccess(response.data);

        } catch (err) {
            if (!err?.response) {
                console.log("No server response");
            } else {
                return handleException(err?.response.data);
            }
        }
    };

    var handleSave = async (e) => {
        e.preventDefault();

        console.log("productData:", productData);


        if (type === "dealershipBroctureCustom") {

        } else {
            var hasInvalidProduct = productData.some((item) => {

                var productName = item.productName || "";
                var productPrice = item.productPrice || "";
                var productMonth = item.productMonth || "";
                var productKM = item.productKM || "";

                return (
                    productName.toString().trim() === "" ||
                    productPrice.toString().trim() === "" ||
                    productMonth.toString().trim() === "" ||
                    productKM.toString().trim() === ""
                );
            });

            if (hasInvalidProduct) {
                alert("Please fill all product fields");
                return;
            }
        }

        var data = {
            userDealership,
            userSalesrep,
            warrantyprotection,
            subCat,
            category,
            subCategory,
            features: JSON.stringify(content),
            products: JSON.stringify(productData),
            pdf,
            deductibleType,
            deductibleAmount
        };

        console.log("Content:", JSON.stringify(productData));
        // dealershipBroctureCustom
        if (type === "add") {

            var mainURL = URL + '/add';

            serviceMethod(
                mainURL,
                'POST',
                data,
                handleSuccess,
                handleException
            );

        } else if (type === "dealershipCustom") {

            if (productCategory == "Salesrep") {

                if (!userSalesrep && !userDealership) {
                    alert("Please Select the Dealership and Salesrep");
                } else {

                    var dealershipURL = URL + '/createsSalesrepProduct';

                    serviceMethod(
                        dealershipURL,
                        'POST',
                        data,
                        handleSuccess,
                        handleException
                    );
                }

            } else {

                if (!userDealership) {
                    alert("Please Select the dealership");
                } else {

                    var dealershipURL = URL + '/createsDealershipProduct';

                    serviceMethod(
                        dealershipURL,
                        'POST',
                        data,
                        handleSuccess,
                        handleException
                    );
                }
            }

        } else if (type === "dealershipBroctureCustom") {



            if (!userDealership) {
                alert("Please Select the dealership");
            } else {
                if (id) {
                    var dealershipURL = URL + '/' + id + '/updateBroutureDealershipProduct';
                } else {
                    var dealershipURL = URL + '/createsBrotureDealershipProduct';
                }

                serviceMethod(
                    dealershipURL,
                    'POST',
                    data,
                    handleSuccess,
                    handleException
                );
            }

        } else if (type == "updateDealershipProduct") {

            if (!userDealership) {
                alert("Please Select the dealership");
            } else {

                var mainURL = URL + '/' + id + '/updateDealershipProduct';

                console.log("url", mainURL);

                serviceMethod(
                    mainURL,
                    'POST',
                    data,
                    handleSuccess,
                    handleException
                );
            }

        } else if (type == "salesrepCustom") {

            if (!userSalesrep) {
                alert("Please Select the Salesrep");
            } else {

                var dealershipURL = URL + '/createsSalesrepProduct';

                serviceMethod(
                    dealershipURL,
                    'POST',
                    data,
                    handleSuccess,
                    handleException
                );
            }

        } else if (type == "updateSalerepProduct") {

            if (!userSalesrep && !userDealership) {
                alert("Please Select the Salesrep & Dealership");
            } else {

                var mainURL = URL + '/' + id + '/updateSalesrepProduct';

                console.log("url", mainURL);

                serviceMethod(
                    mainURL,
                    'POST',
                    data,
                    handleSuccess,
                    handleException
                );
            }

        } else {

            var mainURL = URL + '/' + id + '/update';

            console.log("url", mainURL);

            serviceMethod(
                mainURL,
                'POST',
                data,
                handleSuccess,
                handleException
            );
        }
    };



    var handleSuccess = (data) => {
        setSeverity("success");
        setMessage(data.data);
        setAlertopen(true);
        setPdf("");
        setTimeout(() => {

            console.log("warrantyActionType:" + warrantyActionType);
            (warrantyActionType == "dealershipCustom" || warrantyActionType == "updateDealershipProduct") ? navigate("/ViewDealershipWarrantyProduct")
                : (warrantyActionType == "salesrepCustom" || warrantyActionType == "updateSalesrepProduct") ? navigate("/ViewSalesrepWarrantyProduct")
                    : (warrantyActionType == "dealershipBroctureCustom") ? navigate("/ViewCustomiseDealershipWarrantyProduct")
                        : navigate("/ViewWarrantyProduct");


        }, 6000); // Matches autoHideDuration

    }

    var myTheme = createTheme({
        // Set up your custom MUI theme here
    });


    useEffect(() => {
        console.log("type:" + type);

        setWarrantyActionType(type);

        if (type == "update") {
            setId(value.id || "");
            setCategory(value.category_id || "");
            setProductData(JSON.parse(value.products) || [{ productName: "", productPrice: "", productKM: "", productMonth: "" }]);
            setSubCategory(value.product_subcategory || "");
            setDeductibleAmount(value.deductibleAmount || "");
            setDeductibleType(value.deductibleType || "");
            if (value.category_id) {
                loadSubCategory(value.category_id);
                setSubCat(value.subCat || "");
            }
            if (value.category_id && value.subCat) {
                loadwarrantyprotection(value.category_id, value.subCat);
                setWarrantyprotection(value.warrantyprotection);

            }
            setContent(JSON.parse(value.product_features) || "");
            setPdf(value.PDF || "");
            setPdfFileName(value.PDF ? value.PDF.split("/").pop() : "");


        } else if (type == "updateDealershipProduct") {
            setProductCategory("Dealership")
            loadDealership();
            setUserdealership(value.dealership || "");
            setId(value.id || "");
            setCategory(value.category || "");
            setUserdealership(value.dealership || "");
            // setProductData(JSON.parse(value.products) || [{ productName: "", productPrice: "" }]);
            var parsedProducts = JSON.parse(value.products) || [{ productName: "", productPrice: "", productMonth: "", productKM: "" }];

            var updatedProducts = parsedProducts.map(product => {
                // Only add visibility if it's not already present
                if (!('visiblity' in product)) {
                    return { ...product, visiblity: 1 };
                }
                return product;
            });

            setProductData(updatedProducts);
            setSubCategory(value.subcategory || "");
            if (value.category) {
                loadSubCategory(value.category);
                setSubCat(value.subCat || "");
            }
            if (value.category && value.subCat) {
                loadwarrantyprotection(value.category, value.subCat);
                setWarrantyprotection(value.warrantyprotection);

            }
            setContent(JSON.parse(value.features) || "");
            setPdf(value.PDF || "");
            setPdfFileName(value.PDF ? value.PDF.split("/").pop() : "");


        } else if (type == "updateSalerepProduct") {
            setProductCategory("Salesrep")
            loadDealership();
            setUserdealership(value.dealership || "");
            loadSalesrep(value.dealership);
            setUsersalesrep(value.salesrep);
            setId(value.id || "");
            setCategory(value.category || "");
            setUsersalesrep(value.salesrep || "");
            // setProductData(JSON.parse(value.products) || [{ productName: "", productPrice: "" }]);
            var parsedProducts = JSON.parse(value.products) || [{ productName: "", productPrice: "", productKM: "", productMonth: "" }];

            var updatedProducts = parsedProducts.map(product => {
                // Only add visibility if it's not already present
                if (!('visiblity' in product)) {
                    return { ...product, visiblity: 1 };
                }
                return product;
            });

            setProductData(updatedProducts);
            setSubCategory(value.subcategory || "");
            if (value.category) {
                loadSubCategory(value.category);
                setSubCat(value.subCat || "");
            }
            if (value.category && value.subCat) {
                loadwarrantyprotection(value.category, value.subCat);
                setWarrantyprotection(value.warrantyprotection);

            }
            setContent(JSON.parse(value.features) || "");
            setPdf(value.PDF || "");
            setPdfFileName(value.PDF ? value.PDF.split("/").pop() : "");

        } else if (type == "salesrepCustom") {
            // loadSalesrep();
            setId(value.id || "");
            setCategory(value.category_id || "");
            var parsedProducts = JSON.parse(value.products) || [{ productName: "", productPrice: "", productKM: "", productMonth: "" }];

            // Add visibility: 1 to each item
            var updatedProducts = parsedProducts.map(product => ({
                ...product,
                visiblity: 1
            }));

            setProductData(updatedProducts);
            setSubCategory(value.product_subcategory || "");
            if (value.category_id) {
                loadSubCategory(value.category_id);
                setSubCat(value.subCat || "");
            }
            if (value.category_id && value.subCat) {
                loadwarrantyprotection(value.category_id, value.subCat);
                setWarrantyprotection(value.warrantyprotection);

            }
            setContent(JSON.parse(value.product_features) || "");
            setPdf(value.PDF || "");
            setPdfFileName(value.PDF ? value.PDF.split("/").pop() : "");

        } else if (type == "dealershipCustom") {

            loadDealership();
            setId(value.id || "");
            setCategory(value.category_id || "");
            var parsedProducts = JSON.parse(value.products) || [{ productName: "", productPrice: "", productKM: "", productMonth: "" }];

            // Add visibility: 1 to each item
            var updatedProducts = parsedProducts.map(product => ({
                ...product,
                visiblity: 1
            }));

            setProductData(updatedProducts);
            setSubCategory(value.product_subcategory || "");
            if (value.category_id) {
                loadSubCategory(value.category_id);
                setSubCat(value.subCat || "");
            }
            if (value.category_id && value.subCat) {
                loadwarrantyprotection(value.category_id, value.subCat);
                setWarrantyprotection(value.warrantyprotection);

            }
            setContent(JSON.parse(value.product_features) || "");
            setPdf(value.PDF || "");
            setPdfFileName(value.PDF ? value.PDF.split("/").pop() : "");

        } else if (type == "dealershipBroctureCustom") {
            loadBrotureDealershipProduct();

            // setProductCategory("Dealership")
            // loadDealership();
            // setUserdealership(dealership || "");
            // setId(value.id || "");
            // setCategory(value.category_id || "");
            // var parsedProducts = JSON.parse(value.products) || [{ productName: "", productPrice: "", productKM: "", productMonth: "" }];

            // // Add visibility: 1 to each item
            // var updatedProducts = parsedProducts.map(product => ({
            //     ...product,
            //     visiblity: 1
            // }));

            // setProductData(updatedProducts);
            // setSubCategory(value.product_subcategory || "");
            // if (value.category_id) {
            //     loadSubCategory(value.category_id);
            //     setSubCat(value.subCat || "");
            // }
            // if (value.category_id && value.subCat) {
            //     loadwarrantyprotection(value.category_id, value.subCat);
            //     setWarrantyprotection(value.warrantyprotection);

            // }
            // setContent(JSON.parse(value.product_features) || "");

        } else {
            setId("");
            setCategory("");
            setProductData([{ productName: "", productPrice: "", visiblity: 1, productMonth: "", productKM: "" }]);
            setSubCategory("");
            setContent("");
            setPdf("");
            setPdfFileName("");

        }
        loadCategory();
        // handleSetSubCategory();
    }, [type, value]);

    var handleSaveProduct = () => {
        setProductData([...productData, { productName: "", productPrice: "", visiblity: 1, productMonth: "", productKM: "" }])
    }

    const parseJSON = (value, fallback) => {
        if (value == null || value === "") return fallback;

        try {
            return typeof value === "string" ? JSON.parse(value) : value;
        } catch (error) {
            return fallback;
        }
    };

    const loadBrotureDealershipProduct = async () => {
        const selectedDealership = dealership || value.dealership || "";
        const selectedCategory = value.category_id || value.category || "";
        const selectedSubCat = value.subCat || "";

        setProductCategory("Dealership");
        loadDealership();
        setUserdealership(selectedDealership);
        setCategory(selectedCategory);
        setSubCategory(value.product_subcategory || value.subcategory || "");
        setSubCat(selectedSubCat);

        // Default values from the selected product, used when no saved record exists.
        const defaultProducts = parseJSON(value.products, [
            { productName: "", productPrice: "", productKM: "", productMonth: "" }
        ]);

        const defaultFeatures = parseJSON(value.product_features ?? value.features, "");

        try {
            // Replace BROTURE_LIST_URL with the endpoint that returns the response you shared.
            var BROTURE_LIST_URL = "./product/getBrotureDealershipProduct";

            const response = await axios.post(BROTURE_LIST_URL, {
                dealership: selectedDealership,
                category: selectedCategory,
                subCat: selectedSubCat
            });

            const records = response.data?.data || [];


            // Match all three fields to find the saved dealership-specific product.
            const existingRecord = records.find(item =>
                String(item.dealership) === String(selectedDealership) &&
                String(item.category) === String(selectedCategory) &&
                String(item.subCat) === String(selectedSubCat)
            );

            console.log("Existing Record:", existingRecord);

            if (existingRecord) {
                // Existing record: populate the form for updating.
                setId(existingRecord.id);
                setUserdealership(existingRecord.dealership);
                setCategory(existingRecord.category);
                setSubCat(existingRecord.subCat);
                setSubCategory(existingRecord.subcategory || "");
                setWarrantyprotection(existingRecord.warrantyprotection || "");

                const products = parseJSON(existingRecord.products, []);
                setProductData(
                    products.map(product => ({
                        ...product,
                        visiblity: 1
                    }))
                );

                setContent(parseJSON(existingRecord.features, ""));
                setPdf(existingRecord.PDF || "");
                setPdfFileName(value.PDF ? value.PDF.split("/").pop() : "");
            } else {
                // No existing record: populate defaults for creating.
                setId("");
                setProductData(
                    defaultProducts.map(product => ({
                        ...product,
                        visiblity: 1
                    }))
                );
                setContent(defaultFeatures);

                if (selectedCategory && selectedSubCat) {
                    loadwarrantyprotection(selectedCategory, selectedSubCat);
                    setWarrantyprotection(value.warrantyprotection || "");
                }
            }

            if (selectedCategory) {
                loadSubCategory(selectedCategory);
            }
        } catch (error) {
            console.error("Error loading dealership brochure product:", error);

            setId("");
            setProductData(
                defaultProducts.map(product => ({
                    ...product,
                    visiblity: 1
                }))
            );
            setContent(defaultFeatures);

            if (selectedCategory && selectedSubCat) {
                loadwarrantyprotection(selectedCategory, selectedSubCat);
                setWarrantyprotection(value.warrantyprotection || "");
            }
            if (selectedCategory) {
                loadSubCategory(selectedCategory);
            }

            // If the lookup fails, do not silently treat it as a new record.
            // Otherwise, Save could create a duplicate.
        }
    };

    var loadSubCategory = async (id) => {
        try {
            var URL = "./category/getsubcategorybycat";
            var response = await axios.post(URL, { id: id });

            if (response.data.status === 401) {
                setsubcategoryList([]); // Keep dummy data in case of unauthorized response
            } else {
                var responseData = response.data.data;
                // var dataWithIndex = response.data.data.map((item, index) => ({
                //     ...item,
                //     slNo: index + 1, // Assign sequential SL No starting from 1
                // })) || "";
                setsubcategoryList(responseData);
                // console.log("category data" + response.data.data);
            }
        } catch (err) {
            console.log("Error fetching data:", err);
            // Use dummy data if request fails
            setsubcategoryList([]);
        }
    };

    var loadDealership = async () => {
        try {
            var URL = "./dealership";
            var response = await axios.get(URL);

            if (response.data.status === 401) {
                setDealershipArray(""); // Keep dummy data in case of unauthorized response
            } else {
                var responseData = response.data.data;
                // var dataWithIndex = response.data.data.map((item, index) => ({
                //     ...item,
                //     slNo: index + 1, // Assign sequential SL No starting from 1
                // })) || "";
                setDealershipArray(responseData);
            }
        } catch (err) {
            console.log("Error fetching data:", err);
            // Use dummy data if request fails
            setDealershipArray('');
        }
    };

    var loadSalesrep = async (dealership) => {

        try {
            var URL = "./salesrep";
            var response = await axios.post(URL, { dealership });

            if (response.data.status === 401) {
                setSalesrepArray(""); // Keep dummy data in case of unauthorized response
            } else {
                var responseData = response.data.data;
                // var dataWithIndex = response.data.data.map((item, index) => ({
                //     ...item,
                //     slNo: index + 1, // Assign sequential SL No starting from 1
                // })) || "";
                setSalesrepArray(responseData);
            }
        } catch (err) {
            console.log("Error fetching data:", err);
            // Use dummy data if request fails
            setSalesrepArray('');
        }
    };

    var loadCategory = async (e) => {
        try {
            var URL = "./category";
            var response = await axios.get(URL);

            if (response.data.status === 401) {
                setCategoryList([]); // Keep dummy data in case of unauthorized response
            } else {
                var responseData = response.data.data;
                // var dataWithIndex = response.data.data.map((item, index) => ({
                //     ...item,
                //     slNo: index + 1, // Assign sequential SL No starting from 1
                // })) || "";
                setCategoryList(responseData);
                // console.log("category data" + response.data.data);
            }
        } catch (err) {
            console.log("Error fetching data:", err);
            // Use dummy data if request fails
            setCategoryList('');
        }
    };

    var loadwarrantyprotection = async (category, subcategory) => {
        try {
            var URL = "./category/getwarrantyprobycatsubcat";
            var response = await axios.post(URL, { category: category, subcategory: subcategory });

            if (response.data.status === 401) {
                setWarrantyProtectionList([]); // Keep dummy data in case of unauthorized response
            } else {
                var responseData = response.data.data;
                // var dataWithIndex = response.data.data.map((item, index) => ({
                //     ...item,
                //     slNo: index + 1, // Assign sequential SL No starting from 1
                // })) || "";
                setWarrantyProtectionList(responseData);
                // console.log("category data" + response.data.data);
            }
        } catch (err) {
            console.log("Error fetching data:", err);
            // Use dummy data if request fails
            setWarrantyProtectionList([]);
        }
    };

    var handleProductNameChange = (i, e) => {
        var onchangeVal = [...productData]
        onchangeVal[i]["productName"] = e.target.value;
        setProductData(onchangeVal)
    }

    var handleProductPriceChange = (i, e) => {
        var onchangeVal = [...productData]
        onchangeVal[i]["productPrice"] = e.target.value;
        setProductData(onchangeVal)
    }

    var handleProductMonthChange = (i, e) => {
        var onchangeVal = [...productData];
        onchangeVal[i]["productMonth"] = e.target.value;
        setProductData(onchangeVal);
    }

    var handleProductKmChange = (i, e) => {
        var onchangeVal = [...productData];
        onchangeVal[i]["productKM"] = e.target.value;
        setProductData(onchangeVal);
    }

    var toggleVisibility = (i) => {
        // setProductData((prev) => {
        //     var updated = [...prev];
        //     updated[i] = {
        //         ...updated[i],
        //         visibility: updated[i].visibility === 1 ? 0 : 1
        //     };
        //     return updated;
        // });

        var onchangeVal = [...productData]
        onchangeVal[i]["visiblity"] = onchangeVal[i]["visiblity"] == 0 ? 1 : 0;
        setProductData(onchangeVal)


    };

    var handleProductDescriptionChange = (i, e) => {
        var onchangeVal = [...productData]
        onchangeVal[i]["productDescription"] = e.target.value
        setProductData(onchangeVal)
    }

    var handleDelete = (i) => {
        var deleteVal = [...productData]
        deleteVal.splice(i, 1)
        setProductData(deleteVal)
    }

    var handleSetSubCategory = (e) => {
        console.log("warrantyProtectionText:" + warrantyProtectionText);
        setSubCategory(subCatText + " " + e);
    }

    var handleException = (data) => {
        setSeverity("error");
        setMessage(data.data);
        setAlertopen(true);
    }

    var handleEditorChange = (state) => {
        var rawContent = convertToRaw(state.getCurrentContent());
        console.log("Editor Content:" + rawContent);
    };

    var contentFieldChanaged = (data) => {
        setContent(data);
    }

    var fetchsubcategory = async (e) => {
        loadSubCategory(e.target.value);
    }

    var fetchWarrantyProtection = async (e) => {
        loadwarrantyprotection(category, e.target.value);
    }

    var dealershipChange = (e) => {
        setUserdealership(e.target.value);

        if (productCategory == "Salesrep" && e.target.value) {
            loadSalesrep(e.target.value)
        }


    }


    return (
        <>
            <div style={{ marginTop: '100px', padding: '0px' }}>
                <Typography variant="h5" sx={{ color: 'grey' }}>
                    <TaskIcon sx={{ fontSize: '20px' }} /> &nbsp;Warranty Products
                </Typography>
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        p: 3,
                        border: '1px solid rgb(229 231 235 / 99%);',
                        borderRadius: '8px',
                    }}
                >
                    <Toolbar />
                    <Typography variant="h6">Product Information</Typography>
                    {(type == "dealershipCustom" || type == "updateDealershipProduct" || type == "updateSalerepProduct") || type == "dealershipBroctureCustom" ?
                        <Stack direction="row" spacing={2} sx={{ alignItems: 'center' }}>
                            <FormControl fullWidth sx={{
                                display: type === "dealershipBroctureCustom" ? "none" : "block",
                            }}>
                                <Typography variant="subtitle2" gutterBottom sx={{ marginBottom: '1.0em' }}>
                                    Product Category Type
                                </Typography>
                                <Select
                                    labelId="user-role-select-label"
                                    id="user-role-select"
                                    value={productCategory}
                                    disabled={type == 'updateDealershipProduct' || type == "updateSalerepProduct" || type == "dealershipBroctureCustom"}
                                    onChange={(e) => {
                                        setProductCategory(e.target.value);
                                        setUserdealership('');
                                        setSalesrepArray([]);
                                        setUsersalesrep('');
                                    }}
                                    MenuProps={{
                                        PaperProps: {
                                            style: { maxHeight: 200 },
                                        },
                                    }}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': { borderColor: 'lightgray' },
                                            '&:hover fieldset': { borderColor: 'lightgray' },
                                            '&.Mui-focused fieldset': { borderColor: 'lightgray' },
                                        },
                                    }}
                                >
                                    <MenuItem value="">
                                        <em>Product Category Type</em>
                                    </MenuItem>
                                    {productCategoryType.map((val, index) => (
                                        <MenuItem key={index} value={val}>
                                            {val.charAt(0).toUpperCase() + val.slice(1)}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl fullWidth sx={{
                                display: type === "dealershipBroctureCustom" ? "none" : "block",
                            }}>
                                <Typography variant="subtitle2" gutterBottom sx={{ marginBottom: '1.0em' }}>
                                    Dealership
                                </Typography>

                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={userDealership}
                                    onChange={dealershipChange}
                                    disabled={type == 'updateDealershipProduct' || type == "updateSalerepProduct" || type == "dealershipBroctureCustom"}
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                maxHeight: 200,
                                            },
                                        },
                                    }}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': {
                                                borderColor: 'lightgray',
                                            },
                                            '&:hover fieldset': {
                                                borderColor: 'lightgray',
                                            },
                                            '&.Mui-focused fieldset': {
                                                borderColor: 'lightgray',
                                            },
                                        },
                                    }}
                                >
                                    <MenuItem value="">
                                        <em>Please Select Dealership</em>
                                    </MenuItem>
                                    {dealershipArray.map((dealership, index) => (
                                        <MenuItem key={index} value={dealership.id}>
                                            {dealership.accountName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <FormControl fullWidth sx={{
                                display: type === "dealershipBroctureCustom" ? "none" : "block",
                            }}>
                                <Typography variant="subtitle2" gutterBottom sx={{ marginBottom: '1.0em' }}>
                                    Sales Rep User
                                </Typography>

                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={userSalesrep}
                                    disabled={productCategory == 'Dealership' || type == 'updateDealershipProduct' || type == "updateSalerepProduct"}
                                    onChange={(e) => setUsersalesrep(e.target.value)}
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                maxHeight: 200,
                                            },
                                        },
                                    }}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': {
                                                borderColor: 'lightgray',
                                            },
                                            '&:hover fieldset': {
                                                borderColor: 'lightgray',
                                            },
                                            '&.Mui-focused fieldset': {
                                                borderColor: 'lightgray',
                                            },
                                        },
                                    }}
                                >
                                    <MenuItem value="">
                                        <em>Select Sales Rep</em>
                                    </MenuItem>
                                    {salesrepArray.map((dealership, index) => (
                                        <MenuItem key={index} value={dealership.id}>
                                            {dealership.firstname + " " + dealership.lastname}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Stack> : (type == "salesrepCustom" || type == "updateSalerepProduct") ?
                            <Stack direction="row" spacing={2} sx={{ alignItems: 'center' }}>

                            </Stack> : ""}

                    <br />
                    <Stack direction="row" spacing={2} sx={{ alignItems: 'center' }}>
                        {/* Category Field */}
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Category</InputLabel>
                            <Select
                                id="demo-simple-select"
                                labelId="demo-simple-select-label"
                                value={category}
                                disabled={type == 'updateDealershipProduct' || type == "updateSalerepProduct" || type == "salesrepCustom" || type == "dealershipCustom"}
                                onChange={(e) => { setCategory(e.target.value); fetchsubcategory(e) }}
                                label="Category"
                            >
                                <MenuItem value="">
                                    <em>Please Select Category</em>
                                </MenuItem>
                                {categoryList.map((category, index) => (
                                    <MenuItem key={index} value={category.id}>
                                        {category.categoryName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        {/* Sub Category Field */}
                        <FormControl fullWidth >
                            <InputLabel id="demo-simple-select-label">Sub category</InputLabel>
                            <Select
                                id="demo-simple-select"
                                labelId="demo-simple-select-label"
                                disabled={type == 'updateDealershipProduct' || type == "updateSalerepProduct" || type == "salesrepCustom" || type == "dealershipCustom"}
                                value={subCat}
                                onChange={(e) => {
                                    setSubCat(e.target.value);
                                    fetchWarrantyProtection(e);
                                    setSubCategory("");
                                    var selectedValue = e.target.value;

                                    // Find the selected warranty protection by its id
                                    var selectedSubCategory = subcategoryList.find(subcategory => subcategory.id === selectedValue);

                                    // Get the text value (warrantyprotection)
                                    setSubCatText(selectedSubCategory ? selectedSubCategory.subcategory : '');
                                }}
                                label="Sub category"
                            >
                                <MenuItem value="">
                                    <em>Please Select Subcategory</em>
                                </MenuItem>
                                {subcategoryList.map((subcategory, index) => (
                                    <MenuItem key={index} value={subcategory.id}>
                                        {subcategory.subcategory}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl fullWidth >
                            <InputLabel id="demo-simple-select-label">Warranty Protection</InputLabel>
                            <Select
                                id="demo-simple-select"
                                labelId="demo-simple-select-label"
                                disabled={type == 'updateDealershipProduct' || type == "updateSalerepProduct" || type == "salesrepCustom" || type == "dealershipCustom"}
                                value={warrantyprotection}
                                onChange={(e) => {
                                    setWarrantyprotection(e.target.value);
                                    var selectedValue = e.target.value;
                                    // Find the selected warranty protection by its id
                                    var selectedwarrantyProtection = warrantyProtectionList.find(warrantyprotection => warrantyprotection.id === selectedValue);
                                    // Get the text value (warrantyprotection)
                                    setWarrantyProtectionText(selectedwarrantyProtection ? selectedwarrantyProtection.warrantyprotection : '');
                                    handleSetSubCategory(selectedwarrantyProtection ? selectedwarrantyProtection.warrantyprotection : '');
                                }}
                                label="Warranty Protection"
                            >
                                <MenuItem value="">
                                    <em>Please Select Warranty Protection</em>
                                </MenuItem>
                                {warrantyProtectionList.map((warrantyprotection, index) => (
                                    <MenuItem key={index} value={warrantyprotection.id}>
                                        {warrantyprotection.warrantyprotection}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl fullWidth >
                            {/* <InputLabel id="demo-simple-select-label">Sub Category</InputLabel> */}
                            <TextField
                                // margin="normal"
                                disabled
                                required
                                fullWidth
                                label="Sub category text"
                                value={subCategory}
                                // onChange={(e) => { setSubCategory(e.target.value); }}
                                sx={textfieldStyles}
                            />
                        </FormControl>

                    </Stack>
                    <Stack direction="row" spacing={2} sx={{ alignItems: 'center', marginTop: '15px' }}>

                        {/* Upload PDF Field */}
                        <FormControl fullWidth>
                            {/* <Typography variant="subtitle2" gutterBottom>
                                Upload PDF
                            </Typography> */}

                            {/* Preview existing PDF or newly uploaded PDF */}


                            <TextField
                                fullWidth
                                type="file"
                                label="Choose PDF"
                                inputProps={{ accept: "application/pdf,.pdf" }}
                                InputLabelProps={{ shrink: true }}
                                onChange={(e) => {
                                    const file = e.target.files?.[0];

                                    if (!file) return;

                                    if (
                                        file.type !== "application/pdf" &&
                                        !file.name.toLowerCase().endsWith(".pdf")
                                    ) {
                                        alert("Please select a PDF file.");
                                        e.target.value = "";
                                        return;
                                    }

                                    const reader = new FileReader();

                                    reader.onload = () => {
                                        if (typeof reader.result === "string") {
                                            setPdf(reader.result);
                                        }
                                    };

                                    reader.onerror = () => {
                                        alert("Unable to read the selected PDF.");
                                    };

                                    reader.readAsDataURL(file);
                                }}
                            />

                        </FormControl>
                        <FormControl fullWidth>
                            {pdf && (
                                <Box sx={{ mt: 2, mb: 2, width: "100%" }}>
                                    {/* <Typography variant="subtitle1" gutterBottom>
                                        PDF Preview
                                    </Typography> */}

                                    {/* <iframe
                                        src={
                                            pdf.startsWith("data:") || /^https?:\/\//i.test(pdf)
                                                ? pdf
                                                : `${API_BASE_URL.replace(/\/+$/, "")}/${pdf.replace(/^\/+/, "")}`
                                        }
                                        title="PDF Preview"
                                        width="100%"
                                        height="100px"
                                        style={{
                                            border: "1px solid #ccc",
                                            borderRadius: "8px",
                                        }}
                                    /> */}

                                    <Button
                                        variant="outlined"
                                        sx={{ mt: 1 }}
                                        onClick={() => {
                                            const pdfUrl =
                                                pdf.startsWith("data:") || /^https?:\/\//i.test(pdf)
                                                    ? pdf
                                                    : `${API_BASE_URL.replace(/\/+$/, "")}/${pdf.replace(/^\/+/, "")}`;

                                            window.open(pdfUrl, "_blank", "noopener,noreferrer");
                                        }}
                                    >
                                        Preview Uploaded File
                                    </Button>
                                    {pdfFileName && (
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                mb: 1,
                                                color: "text.secondary",
                                                fontWeight: 500,
                                                wordBreak: "break-word",
                                            }}
                                        >
                                            <b>Uploaded File:</b> {pdfFileName}
                                        </Typography>
                                    )}
                                </Box>
                            )}
                        </FormControl>


                    </Stack>

                    <br />
                    <Stack direction="row" spacing={14} sx={{ alignItems: 'flex-start' }}>
                        <FormControl>
                            <Typography variant="subtitle2">Product Feature</Typography>
                            <Editor value={content} onTextChange={(e) => setContent(e.htmlValue)} style={{ height: '320px' }} />
                        </FormControl>
                        <FormControl style={{ display: type === "dealershipBroctureCustom" ? 'none' : 'flex' }}>
                            <FormLabel>Deductible</FormLabel>
                            <RadioGroup
                                row
                                value={deductibleType}
                                onChange={handleRadioChange}
                            >
                                <FormControlLabel
                                    value="1"
                                    control={<Radio />}
                                    label="Default"
                                />
                                <FormControlLabel
                                    value="2"
                                    control={<Radio />}
                                    label="Custom"
                                />
                            </RadioGroup>

                            <TextField
                                label="Amount"
                                type="text"
                                size="small"
                                value={deductibleAmount}
                                onChange={(e) => {
                                    var value = e.target.value;

                                    // Allow numbers with one decimal point
                                    if (/^\d*\.?\d*$/.test(value)) {
                                        setDeductibleAmount(value);
                                    }
                                }}
                                disabled={deductibleType == 1}
                                inputProps={{
                                    inputMode: "decimal",
                                }}
                            />
                        </FormControl>
                    </Stack>
                    <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>

                    </Stack>

                    {
                        productData.map((product, index) => (



                            <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                                <FormControl fullWidth key={index}>
                                    <Typography variant="subtitle2">Product Name</Typography>
                                    <TextField
                                        margin="normal"
                                        required
                                        fullWidth
                                        id={`product-name-${index}`}
                                        value={product.productName}
                                        onChange={(e) => handleProductNameChange(index, e)}
                                        sx={textfieldStyles}
                                    />
                                </FormControl>
                                <FormControl fullWidth key={index}>
                                    <Typography variant="subtitle2">Product Month</Typography>
                                    <TextField
                                        type="text"
                                        margin="normal"
                                        required
                                        fullWidth
                                        id={`product-name-${index}`}
                                        value={product.productMonth}
                                        sx={textfieldStyles}

                                        inputProps={{
                                            inputMode: "numeric", // mobile numeric keyboard
                                            pattern: "[0-9]*"
                                        }}

                                        onChange={(e) => {
                                            var value = e.target.value;
                                            if (/^\d*$/.test(value)) {
                                                handleProductMonthChange(index, e);
                                            }
                                        }}
                                    />
                                </FormControl>
                                <FormControl fullWidth key={index}>
                                    <Typography variant="subtitle2">Product KM</Typography>
                                    <TextField
                                        margin="normal"
                                        required
                                        fullWidth
                                        id={`product-name-${index}`}
                                        value={product.productKM}
                                        onChange={(e) => handleProductKmChange(index, e)}
                                        sx={textfieldStyles}
                                    />
                                </FormControl>
                                {/* <FormControl fullWidth key={index}> */}
                                {/* <Typography variant="subtitle2">Product Description</Typography> */}
                                {/* <ThemeProvider theme={myTheme}>
                                        <MUIRichTextEditor
                                            label="Type something here..."
                                            onChange={handleEditorChange}
                                            inlineToolbar={true}
                                            classes={{
                                                root: classes.editor,
                                            }}
                                        />
                                    </ThemeProvider> */}
                                {/* <JoditEditor
                                        ref={editor}
                                        value={content}

                                        onChange={(newContent) => contentFieldChanaged(newContent)}
                                    /> */}
                                {/* <TextField
                                        margin="normal"
                                        required
                                        fullWidth
                                        id={`product-name-${index}`}
                                        value={product.productDescription}
                                        onChange={(e) => handleProductDescriptionChange(index, e)}
                                        sx={textfieldStyles}
                                    /> */}
                                {/* </FormControl> */}
                                <FormControl fullWidth key={index}>
                                    <Typography variant="subtitle2">{type === "dealershipBroctureCustom" ? "Retail Price" : "Product Price"}    </Typography>
                                    <TextField
                                        margin="normal"
                                        required
                                        fullWidth
                                        id={`product-name-${index}`}
                                        value={product.productPrice}
                                        sx={textfieldStyles}
                                        inputProps={{
                                            inputMode: "numeric",
                                            pattern: "[0-9]*"
                                        }}
                                        onChange={(e) => {
                                            var value = e.target.value;
                                            if (/^\d*$/.test(value)) {
                                                handleProductPriceChange(index, e);
                                            }
                                        }}
                                    />
                                </FormControl>
                                {

                                    type == "salesrepCustom" || type == "dealershipCustom" || type == "updateSalerepProduct" || type == "updateDealershipProduct" ?

                                        <IconButton
                                            onClick={() => toggleVisibility(index)}
                                            color="primary"
                                        >
                                            {product.visiblity == "1" ? (
                                                <VisibilityIcon />
                                            ) : (
                                                <VisibilityOffIcon />
                                            )}
                                        </IconButton> :
                                        <Button
                                            // startIcon={<AddIcon fontSize="var(--icon-fontSize-md)" />}
                                            size="medium"
                                            variant="contained"
                                            sx={{
                                                backgroundColor: '#0d2365',
                                                '&:hover': {
                                                    backgroundColor: '#0d2365',
                                                },
                                                borderRadius: '5px',
                                                padding: '',
                                                display: type === "dealershipBroctureCustom" ? 'none' : 'flex',
                                            }}
                                            onClick={() => handleDelete(index)}
                                        >
                                            <DeleteOutlineIcon />
                                        </Button>
                                }


                            </Stack>


                        ))
                    }




                    <>
                        {/* <p>{JSON.stringify(productData)}</p> */}
                        {/* <div
                            dangerouslySetInnerHTML={{ __html: content }}
                            style={{ border: "1px solid #ccc", padding: "10px", marginTop: "20px" }}
                        /> */}
                    </>




                    <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                        <Button
                            startIcon={<AddIcon fontSize="var(--icon-fontSize-md)" />}
                            size="large"
                            variant="contained"
                            sx={{
                                backgroundColor: '#0d2365',
                                '&:hover': {
                                    backgroundColor: '#0d2365',
                                },
                                borderRadius: '10px'
                            }}
                            onClick={handleSave}
                        >
                            Save
                        </Button>
                        <Button
                            // startIcon={<AddIcon fontSize="var(--icon-fontSize-md)" />}
                            size="large"
                            variant="contained"
                            sx={{
                                backgroundColor: '#0d2365',
                                '&:hover': {
                                    backgroundColor: '#0d2365',
                                },
                                borderRadius: '10px'
                            }}
                            onClick={handleSaveProduct}
                        >
                            Add New Product
                        </Button>
                        {/* <Button
                            startIcon={<AddIcon fontSize="var(--icon-fontSize-md)" />}
                            size="large"
                            variant="contained"
                            sx={{
                                backgroundColor: '#0d2365',
                                '&:hover': {
                                    backgroundColor: '#0d2365',
                                },
                                borderRadius: '10px'
                            }}
                            onClick={handleSave}
                        >
                            fetch
                        </Button> */}
                    </Stack>

                    <Snackbar open={alertOpen} autoHideDuration={6000} onClose={handleClose}>
                        <Alert
                            onClose={handleClose}
                            severity={severity}
                            variant="filled"
                            sx={{ width: '100%' }}
                        >
                            {message}
                        </Alert>
                    </Snackbar>
                </Box>
            </div>
        </>
    );
}

var textfieldStyles = {
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: 'lightgray', // Default border color
        },
        '&:hover fieldset': {
            borderColor: 'lightgray', // Remove hover border color
        },
        '&.Mui-focused fieldset': {
            borderColor: 'lightgray', // Remove focus border color
        },
    },
};

export default WarrantyProducts;
